export const extractFirstVideoFrame = async (videoSrc: string) => {
  try {
    const video = await getVideoFrame(videoSrc)

    const blob = await drawFrameToCanvas(video)
    return blob
  } catch (error) {
    // biome-ignore lint/suspicious/noConsole: callers fall back silently, so this is the only trace of a failed extraction
    console.error('Error extracting frame:', error)
  }
}

const getVideoFrame = async (videoSrc: string) => {
  const video = document.createElement('video')

  video.src = videoSrc
  video.crossOrigin = 'anonymous'
  video.muted = true
  video.playsInline = true
  video.preload = 'metadata'

  await new Promise((resolve, reject) => {
    video.onloadedmetadata = resolve
    video.onerror = reject
  })

  video.currentTime = 0.1

  await new Promise((resolve, reject) => {
    video.onseeked = resolve
    video.onerror = reject
  })

  return video
}

const drawFrameToCanvas = async (video: HTMLVideoElement) => {
  const canvas = document.createElement('canvas')
  canvas.width = video.videoWidth
  canvas.height = video.videoHeight

  const ctx = canvas.getContext('2d')
  ctx?.drawImage(video, 0, 0, canvas.width, canvas.height)

  const toBlobPromise = new Promise<string>((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error('Failed to extract frame from video'))
        return
      }
      const blobUrl = URL.createObjectURL(blob)
      resolve(blobUrl)
    }, 'image/png')
  })
  return await toBlobPromise
}
